import { render, staticRenderFns } from "./ActeTypeClientArea.vue?vue&type=template&id=2d418b8b&"
import script from "./ActeTypeClientArea.vue?vue&type=script&lang=js&"
export * from "./ActeTypeClientArea.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports